import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/marketing/')({
  component: () => <PageStub title="Marketing Hub" description="Marketing tools and campaigns" />,
});
